import qs from 'qs';
import axiosInstances from '@/helper/axiosInstances';

const baseURL = import.meta.env.VITE_API_URL;

export default function user() {
	// Get fresh instances for each request
	const getInstance = () => {
		const { axiosInstance, axiosInstanceF } = axiosInstances();
		return { axiosInstance, axiosInstanceF };
	};

	async function getUsers(params) {
		const { axiosInstance } = getInstance();
		const method = 'get';
		const url = `${baseURL}usertabledoc/`;
		const response = await axiosInstance.request({
			method,
			url,
			params,
			paramsSerializer: (params) => {
				return qs.stringify(params, { arrayFormat: 'repeat', encode: false });
			},
		});
		return response;
	}

	async function getUser(id) {
		const { axiosInstance } = getInstance();
		const method = 'get';
		const url = `${baseURL}usertabledoc/${id}/`;
		const response = await axiosInstance.request({
			method,
			url,
		});
		return response;
	}

	async function getUsersTemporary(params) {
		const { axiosInstance } = getInstance();
		const method = 'get';
		const url = `${baseURL}tempuser/`;
		const response = await axiosInstance.request({
			method,
			url,
			params,
		});
		return response;
	}

	async function getPrivilegeLevels(params) {
		const { axiosInstance } = getInstance();
		const method = 'get';
		let url = `${baseURL}privilegelevelsdoc/`;
		const response = await axiosInstance.request({
			method,
			url,
			params,
		});
		return response;
	}

	async function getSASToken(data) {
		const { axiosInstanceF } = getInstance();
		const method = 'post';
		const url = `${baseURL}sas_temporary/`;
		const response = await axiosInstanceF.request({
			method,
			url,
			data,
		});
		return response;
	}

	return { getUser, getUsers, getUsersTemporary, getPrivilegeLevels, getSASToken };
}
